import * as React from 'react';

import LoginForm from '../../components/LoginForm/LoginForm';

import styles from './LoginPage.module.scss';
class LoginPage extends React.Component<{}>{

  public render(){

    return (
      <div className={styles.loginPage}>
        <LoginForm/>
      </div>
    )
  }

}

export default LoginPage;
